import * as React from "react";
const SvgFiRrArrowAltRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23.768 11.448 19.35 7.087c-.498-.492-1.35-.143-1.35.552v3.36H1a1 1 0 1 0 0 2h17v3.362c0 .695.852 1.044 1.35.552l4.418-4.361a.773.773 0 0 0 0-1.104"
    />
  </svg>
);
export default SvgFiRrArrowAltRight;
